'use client';

import { c as _c } from "react/compiler-runtime";
import useUser from '@shared/utils/hooks/useUser';
import { Logo } from '@shared/utils/icons';
import { Menu, X } from 'lucide-react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';
import { client } from '../../utils/trpc';
import { useAuthModals } from '../../widgets/WidgetsContext';
import Button from '../common/Button';
const AboutHeader = () => {
  const $ = _c(49);
  const {
    currentUser
  } = useUser();
  const router = useRouter();
  const {
    openSignupModal
  } = useAuthModals();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [pitchCount, setPitchCount] = useState(0);
  const headerRef = useRef(null);
  let t0;
  let t1;
  if ($[0] !== isMobileMenuOpen) {
    t0 = () => {
      if (!isMobileMenuOpen) {
        return;
      }
      const handleClickOutside = e => {
        if (headerRef.current && !headerRef.current.contains(e.target as Node)) {
          setIsMobileMenuOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    };
    t1 = [isMobileMenuOpen];
    $[0] = isMobileMenuOpen;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== currentUser?.isAuthenticated) {
    t2 = () => {
      if (!currentUser?.isAuthenticated) {
        return;
      }
      client.pitch.myPitches.query().then(t3 => {
        const [error, data] = t3;
        if (!error && data) {
          setPitchCount(data.length);
        }
      });
    };
    $[3] = currentUser?.isAuthenticated;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = currentUser?.isAuthenticated;
  let t4;
  if ($[5] !== t3) {
    t4 = [t3];
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  useEffect(t2, t4);
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [{
      name: "Explore",
      href: "/home"
    }, {
      name: "Features",
      href: "#features"
    }, {
      name: "Pricing",
      href: "#pricing"
    }, {
      name: "Contact",
      href: "#contact"
    }];
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const navigation = t5;
  let t6;
  if ($[8] !== router) {
    t6 = href => {
      if (href.startsWith("#")) {
        const element = document.querySelector(href);
        if (element) {
          element.scrollIntoView({
            behavior: "smooth"
          });
        }
      } else {
        router.push(href);
      }
      setIsMobileMenuOpen(false);
    };
    $[8] = router;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const scrollToSection = t6;
  const t7 = currentUser?.isAuthenticated ? "/home" : "/";
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Logo height={32} rounded={true} />;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t7) {
    t9 = <Link href={t7} className="flex items-center" aria-label="Factiii home">{t8}</Link>;
    $[11] = t7;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== scrollToSection) {
    t10 = <nav className="hidden items-center space-x-8 md:flex">{navigation.map(item => <button key={item.name} onClick={() => scrollToSection(item.href)} className="font-emphasis text-textSecondary transition-colors duration-200 hover:text-primary">{item.name}</button>)}</nav>;
    $[13] = scrollToSection;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== currentUser?.isAuthenticated || $[16] !== pitchCount || $[17] !== router) {
    t11 = currentUser?.isAuthenticated && pitchCount > 0 && <Button onClick={() => router.push("/pitch")} variant="SECONDARY" text={pitchCount === 1 ? "View Pitch" : "View Pitches"} classNames="px-6 py-2" />;
    $[15] = currentUser?.isAuthenticated;
    $[16] = pitchCount;
    $[17] = router;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== currentUser?.isAuthenticated || $[20] !== openSignupModal || $[21] !== router) {
    t12 = currentUser?.isAuthenticated ? <Button onClick={() => router.push("/home")} variant="SECONDARY" text="Go to App" classNames="px-6 py-2" /> : <Button onClick={openSignupModal} variant="PRIMARY" text="Get Started" classNames="px-6 py-2" />;
    $[19] = currentUser?.isAuthenticated;
    $[20] = openSignupModal;
    $[21] = router;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t11 || $[24] !== t12) {
    t13 = <div className="hidden items-center space-x-4 md:flex">{t11}{t12}</div>;
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== isMobileMenuOpen) {
    t14 = () => setIsMobileMenuOpen(!isMobileMenuOpen);
    $[26] = isMobileMenuOpen;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== isMobileMenuOpen) {
    t15 = isMobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />;
    $[28] = isMobileMenuOpen;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== isMobileMenuOpen || $[31] !== t14 || $[32] !== t15) {
    t16 = <div className="md:hidden"><button onClick={t14} aria-expanded={isMobileMenuOpen} aria-label="Toggle navigation menu" className="p-2 text-textSecondary transition-colors hover:text-primary">{t15}</button></div>;
    $[30] = isMobileMenuOpen;
    $[31] = t14;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t10 || $[35] !== t13 || $[36] !== t16 || $[37] !== t9) {
    t17 = <div className="flex h-16 items-center justify-between">{t9}{t10}{t13}{t16}</div>;
    $[34] = t10;
    $[35] = t13;
    $[36] = t16;
    $[37] = t9;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== currentUser?.isAuthenticated || $[40] !== isMobileMenuOpen || $[41] !== openSignupModal || $[42] !== pitchCount || $[43] !== router || $[44] !== scrollToSection) {
    t18 = isMobileMenuOpen && <div className="md:hidden"><div className="space-y-1 border-t border-ds-border-standard bg-background-primary px-2 pb-3 pt-2">{navigation.map(item_0 => <button key={item_0.name} onClick={() => scrollToSection(item_0.href)} className="block w-full rounded-md px-3 py-2 text-left font-emphasis text-textSecondary transition-colors duration-200 hover:bg-background-light hover:text-primary">{item_0.name}</button>)}<div className="space-y-1 pt-2">{currentUser?.isAuthenticated && pitchCount > 0 && <button onClick={() => {
            router.push("/pitch");
            setIsMobileMenuOpen(false);
          }} className="block w-full rounded-md px-3 py-2 text-left font-emphasis text-textSecondary transition-colors duration-200 hover:bg-background-light hover:text-primary">{pitchCount === 1 ? "View Pitch" : "View Pitches"}</button>}{currentUser?.isAuthenticated ? <button onClick={() => {
            router.push("/home");
            setIsMobileMenuOpen(false);
          }} className="block w-full rounded-md px-3 py-2 text-left font-emphasis text-textSecondary transition-colors duration-200 hover:bg-background-light hover:text-primary">Go to App</button> : <Button onClick={() => {
            openSignupModal();
            setIsMobileMenuOpen(false);
          }} variant="PRIMARY" text="Get Started" classNames="w-full px-6 py-2" />}</div></div></div>;
    $[39] = currentUser?.isAuthenticated;
    $[40] = isMobileMenuOpen;
    $[41] = openSignupModal;
    $[42] = pitchCount;
    $[43] = router;
    $[44] = scrollToSection;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== t17 || $[47] !== t18) {
    t19 = <header ref={headerRef} className="fixed top-0 z-50 w-full border-b border-ds-border-standard bg-background-primary/95 backdrop-blur-sm"><div className="mx-auto max-w-7xl px-6">{t17}{t18}</div></header>;
    $[46] = t17;
    $[47] = t18;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  return t19;
};
export default AboutHeader;